<form [formGroup]="form">
  <app-input-group>
    <label appLabel>{{ 'common.changedate' | translate }}</label>
    <input type="date" appInput formControlName="validFrom">
  </app-input-group>
  <app-calculation-form
    [form]="form"
    [rowHandler]="rowHandler"
    [algorithmDynamic]="algorithmDynamic">
  </app-calculation-form>
</form>

